import { render } from "./CollectionTable.vue?vue&type=template&id=4e14d8f6&scoped=true"
import script from "./CollectionTable.vue?vue&type=script&lang=js"
export * from "./CollectionTable.vue?vue&type=script&lang=js"

import "./CollectionTable.vue?vue&type=style&index=0&id=4e14d8f6&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e14d8f6"]])

export default __exports__